import React, {Component} from 'react';
import PropTypes from "prop-types";
import "./ratingstars.css";

class RatingStars extends Component {
    render() {
        const { size, value, starSize } = this.props;

        const linear = (star) => {
            const percent = value > star ? 100 : ((1 - (star - value)) * 100)
            return `linear-gradient(90deg, #f1d72d 0%, #f1d72d ${percent}%, rgba(242,242,242,1) ${percent}%, rgba(242,242,242,1) 100%)`;
        }
        return (
            <div className={`stars--rating--wrapper ${starSize}`}>
                {Array(size).fill(0).map((_, index) => (
                    <div key={index} className={`star--item ${starSize}`} style={{ background: linear(index + 1)}} />
                ))}
            </div>
        );
    }
}

RatingStars.propType = {
    value: PropTypes.number.isRequired,
    size: PropTypes.number,
    starSize: PropTypes.oneOf(['middle', 'small', 'large'])
}

RatingStars.defaultProps = {
    value: 0,
    size: 5,
    starSize: "middle"
}

export default RatingStars;


// WEBPACK FOOTER //
// ./src/components/rating-stars/RatingStars.jsx